import React from 'react';

export type ChipVariant = 'success' | 'warning' | 'error' | 'processing' | 'info' | 'default' | 'primary';

export interface ChipProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: ChipVariant;
  icon?: React.ReactNode;
  removable?: boolean;
  onRemove?: () => void;
  size?: 'default' | 'sm';
}

export const Chip = React.forwardRef<HTMLSpanElement, ChipProps>(
  (
    {
      variant = 'default',
      icon,
      removable = false,
      onRemove,
      size = 'default',
      children,
      className = '',
      ...props
    },
    ref
  ) => {
    const variantClasses: Record<ChipVariant, string> = {
      success: 'chip-success',
      warning: 'chip-warning',
      error: 'chip-error',
      processing: 'chip-processing',
      info: 'chip-info',
      default: 'chip',
      primary: 'chip-primary',
    };

    const sizeClass = size === 'sm' ? 'text-[10px] h-20 px-2' : '';

    return (
      <span
        ref={ref}
        className={`chip ${variantClasses[variant]} ${sizeClass} ${className}`}
        {...props}
      >
        {icon && <span className="flex-shrink-0">{icon}</span>}
        {children}
        {removable && (
          <button
            type="button"
            onClick={onRemove}
            className="ml-1 flex items-center justify-center w-5 h-5 rounded-full hover:bg-black/10 transition-colors"
            aria-label="Remover"
          >
            <span className="material-symbols-outlined text-[16px]">close</span>
          </button>
        )}
      </span>
    );
  }
);

Chip.displayName = 'Chip';